import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import {
  FormLabel,
  InputText,
  TextV2,
  SvgSearchRegular,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { styled } from '@mui/material';

type ListFilterProps = {
  label: string;
  fieldLabel: string;
  placeholder: string;
  searchTerm: string;
  handleTermChange: (s: string) => void;
};

const StyledForm = styled('form')(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  flexShrink: '0',
  marginLeft: theme.spacing(spacingSizeMap.S),
}));

const StyledDiv = styled('div')(({ theme }) => ({
  display: 'inline-flex',
  flexShrink: '0',
  paddingTop: theme.spacing(spacingSizeMap.XS),
  paddingRight: theme.spacing(spacingSizeMap.S),
}));

const ListFilter = ({
  label,
  fieldLabel,
  placeholder,
  searchTerm,
  handleTermChange,
}: ListFilterProps) => {
  const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    handleTermChange(e.currentTarget.value);
  };
  const handleSearchClear = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      handleTermChange('');
    }
  };
  return (
    <Grid
      container
      sx={{
        alignItems: 'baseline',
        justifyContent: 'space-between',
      }}
    >
      <Paper
        sx={(theme) => ({
          flexGrow: `1`,
          margin: `${theme.spacing(spacingSizeMap.M)} 0`,
          padding: `${theme.spacing(spacingSizeMap.M)} ${theme.spacing(
            spacingSizeMap.S,
          )}`,
        })}
      >
        <Grid
          container
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid
            wrap="nowrap"
            container
            size={8}
            sx={{
              alignItems: 'center',
            }}
          >
            <StyledForm autoComplete="off" onSubmit={(e) => e.preventDefault()}>
              <FormLabel
                label={
                  <StyledDiv>
                    <TextV2 component="p">{label}</TextV2>
                    <TextV2 component="p" variant="bodyBold">
                      &nbsp;
                      {fieldLabel}
                    </TextV2>
                  </StyledDiv>
                }
                htmlFor="search-filter-input"
              />
              <InputText
                icon={<SvgSearchRegular />}
                id="search-filter-input"
                label=""
                placeholder={placeholder}
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyDown={handleSearchClear}
              />
            </StyledForm>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
export default ListFilter;
